<template>
  <div class="infinite" ref="container">
    <slot></slot>
  </div>
</template>

<script>
  import _ from 'lodash'
  import queryString from 'query-string'

  export default {
    data() {
      return {
        isMore: true,
        checkState: true,
        isEmpty: false
      }
    },
    props: [
      'endpoint'
    ],
    computed: {
      page() {
        return this.$store.getters.getPropertiesPage
      }
    },
    methods: {
      loadMoreProperties() {
        if (this.checkState === false) return;
        this.checkState = false;
        if (!this.isMore) {
          return
        }
        
        if (!this.isEmpty) {
          $('.infinite').addClass('infinite__elements-loading');
        }

        window.axios.get('/api/' + this.endpoint + '?list=1&' + queryString.stringify(_.assign(
          queryString.parse(window.location.search),
          { page: this.page }
        ))).then((response) => {
          this.checkState = true;
          if (response.data.data.length) {

            this.$store.commit('INCREASE_PROPERTIES_PAGE')
            this.$store.commit('PUSH_TO_PROPERTIES_COLLECTION', response.data.data)
          } else {
            this.isMore = false;
            $('.infinite').removeClass('infinite__elements-loading');
          }
          
          if (response.data.to == response.data.total) this.isEmpty = true;

          setTimeout(function () {
            document.querySelectorAll('.func-properties-photo').forEach(function (el) {
              el.oncontextmenu = function () {
                return false;
              };
            });
          }, 700);
        }).finally(() => {
            $('.infinite').removeClass('infinite__elements-loading');
        });
      }
    },
    mounted() {
      window.addEventListener('scroll', _.throttle(() => {
        if (this.$refs.container.getBoundingClientRect().bottom < window.innerHeight) {
          this.loadMoreProperties()
        }
      }, 500))
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/components/InfiniteScroll.vue